import angular from 'angular';

angular.module('dashboard');

class batchRouteCtrl {
  /* @ngInject */
  constructor($scope, $state, $translate, $sessionStorage, toastr, i18nService, CompanyService) {
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.$sessionStorage = $sessionStorage;
    this.toastr = toastr;
    this.i18nService = i18nService;
    this.CompanyService = CompanyService;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());

    // Nom de l'onglet actif
    this.activeTabName = this.activeTab.tabName;

    // Fournit aux onglets l'indication d'utiliser des critères de recherche spécifiques
    if (this.activeTabName === 'rebroadcast') {
      this.specificFormRebroadcast = this.specificForm;
    } else if (this.activeTabName === 'indexfileOverdue') {
      this.specificFormBatch = 'indexfileOverdue';
    } else if (this.activeTabName === 'unknownBatchRef') {
      this.specificFormUnknownBatchRef = this.specificForm;
    } else {
      this.specificFormBatch = this.specificForm;
    }

    this.loadFromHisto = this.loadFromHisto;
    this.activeTabIndex = 0;

    this.$scope.getTableHeight = function(gridApi) {
      var rowHeight = 30;
      var headerHeight = 30;
      var scrollHeight = 20;
      var footerHeight = 32;
      return {
        height:
          gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight +
          headerHeight +
          scrollHeight +
          footerHeight +
          'px'
      };
    };

    // Initialise l'état initial des onglets
    this.updateTabStatus();
  }

  // Change l'onglet actif
  selectTab(tabName) {
    if (this.activeTabName === tabName) {
      return;
    }
    this.activeTabName = tabName;
    this.$state.go('batches', { tabName: tabName, specificForm: null });
    this.updateTabStatus();
  }

  updateTabStatus() {
    if (this.activeTabName === 'processdelay') {
      this.activeTabIndex = 4;
    } else if (this.activeTabName === 'unknownBatchRef') {
      this.activeTabIndex = 3;
    } else if (this.activeTabName === 'indexfileOverdue') {
      this.activeTabIndex = 2;
    } else if (this.activeTabName === 'rebroadcast') {
      this.activeTabIndex = 1;
    } else {
      this.activeTabIndex = 0;
    }
  }
}

angular.module('dashboard').component('batchRoute', {
  templateUrl: require('./batch-route.html'),
  controller: batchRouteCtrl,
  bindings: {
    specificForm: '<',
    activeTab: '<',
    keepFilter: '<'
  }
});
